import { LoadState } from "../../constants/enums";
import { IFeeStructure, IFeeStructureState } from "./feeStructure.types";

export const defaultFeeStructure:IFeeStructure={
    fee_structure_id: null,
  fee_structure_unique_id: "",
  fee_structure_uuid: null,
  organizations_uuid: "",
  organizations_name: "",
  fee_override_uuid: "",
  courses_uuid: "",
  courses_name: "",
  batch: "",
  academic_year: 0,
  fee_type: "",
  custom_fee_type: "",
  fee_amount: 0,
  fee_description: "",
  is_changable: false,
   is_optional: false,
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
  total_fee_amount: "",
  fees_paid: "",
  pending_fee: "",
  start_date: "",
  due_date: "",
  notice_period: 0,
  fine_type: "",
    fine_percentage: 0,
    fine_amount: 0,
    status: "",
    next_run_date: "",
   
}

export const defaultFeeStructureState:IFeeStructureState={
    list:{
        data:[],
        totalRecords:0,
        loading:LoadState.NotLoaded,
        error:""
    },
    feeStructure:{
        data:defaultFeeStructure,
        loading:LoadState.NotLoaded,
        error:""
    }
}